import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import {
  Avatar,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";

interface Props {
  messageText: string;
  fullName: string;
  gender: string;
  repliedFiles: any;
}

const RepliedCard = ({
  messageText,
  fullName,
  gender,
  repliedFiles,
}: Props) => {
  const [showMore, setShowMore] = React.useState(false);
  const maxChars = 60;
  const openInNewTab = (url: any) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  return (
    <div>
      <Card
        sx={{
          maxWidth: 345,
          direction: "rtl",
          background: "#485E74 !important",
          color: "#fff",
          border: "none",
          Width: 300,
          minHeight: "80px",
          paddingX: "1rem",
          overflow: "initial !important",
          borderRadius: "5px !important",
        }}
      >
        <CardHeader
          color="#fff !important"
          className="chat-header"
          sx={{
            paddingTop: "10px !important",
            paddingBottom: "0px !important",
            paddingRight: "0px !important",
          }}
          avatar={
            <Avatar
              className="chat-card-avatar-reply"
              sx={{
                bgcolor: "E5E1DA",
                marginLeft: "7px",
              }}
              aria-label="recipe"
            >
              {gender.toLocaleLowerCase() === "female" ? (
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                  src="images/person_3_black_24dp.svg"
                  alt="female user"
                />
              ) : (
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                  src="images/person_black_24dp.svg"
                  alt="male user"
                />
              )}
            </Avatar>
          }
          title={<span style={{ color: "#fff" }}>{fullName}</span>}
        />

        <CardContent
          sx={{
            marginTop: "0.5rem",
            paddingTop: "4px",
            paddingBottom: "10px !important",
            paddingLeft: "3px !important",
            paddingRight: "10px !important",
          }}
        >
          <Grid container justifyContent={"center"} alignItems={"center"}>
            <Grid item xs={10}>
              {repliedFiles.map(
                (file: any) =>
                  file !== null &&
                  (file.fileType.toLocaleLowerCase() === "image" ? (
                    <span className="chatCard-imagePrev-container">
                      <img
                        src={
                          file.thumbnailFileUrl !== null
                            ? file.thumbnailFileUrl
                            : file.fileUrl
                        }
                        alt={file.fileName}
                        className="chatCard-imagePrev"
                        onClick={() => {
                          openInNewTab(file.fileUrl);
                        }}
                      />
                    </span>
                  ) : (
                    <>
                      <a href={file.fileUrl} target="_blank">
                        <PictureAsPdfOutlinedIcon
                          className={"uploadImageCmpIconPDFReply"}
                          // style={{ marginTop: "1vh" }}
                        />
                      </a>
                    </>
                  ))
              )}
            </Grid>
          </Grid>

          {messageText !== null && (
            <Typography
              variant="body2"
              color="#fff"
              lineHeight={"1.5rem"}
              fontSize={"13px"}
              marginBottom={"7px"}
              textAlign={"justify"}
              sx={{ wordWrap: "break-word", width: "250px" }}
            >
              {showMore ? messageText : `${messageText.substring(0, maxChars)}`}
              {messageText.length >= maxChars && (
                <Button
                  onClick={() => setShowMore(!showMore)}
                  sx={{
                    position: "static !important",
                    color: "#18FFFF",
                    padding: "0 !important",
                    marginTop: "4px",
                  }}
                >
                  {showMore ? "کمتر" : "بیشتر"}
                </Button>
              )}
            </Typography>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default RepliedCard;
